module.exports = __webpack_public_path__ + "static/media/MS-Sans-Serif.c44c9568.woff";